import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Close, Email, Instagram, LinkedIn, Menu } from "@mui/icons-material";

const features = [
  {
    title: "Definição de Metas",
    description:
      "Estabeleça objetivos claros e mensuráveis para orientar o crescimento da sua organização.",
    icon: "🎯",
  },
  {
    title: "Análise SWOT Integrada",
    description:
      "Identifique forças, fraquezas, oportunidades e ameaças para embasar suas decisões estratégicas.",
    icon: "📊",
  },
  {
    title: "Controle de Métricas (KPI)",
    description:
      "Acompanhe o desempenho em tempo real para garantir o cumprimento das metas estabelecidas.",
    icon: "📈",
  },
  {
    title: "Gestão de Projetos",
    description:
      "Organize e gerencie iniciativas estratégicas com eficiência, assegurando a execução alinhada aos objetivos corporativos.",
    icon: "📋",
  },
  {
    title: "Colaboração em Equipe",
    description:
      "Facilite a comunicação e o trabalho conjunto entre membros da equipe, promovendo um ambiente colaborativo e produtivo.",
    icon: "🤝",
  },
  {
    title: "Automatização de Processos",
    description:
      "Utilize fluxos automatizados para reduzir tarefas manuais e aumentar a eficiência operacional.",
    icon: "⚙️",
  },
];

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleEntrar = () => {
    navigate("/tw/login");
  };

  const handleAssinaturaClick = () => {
    // Navigate to signup or subscription page instead of requiring login first
    navigate("/tw/register");
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="bg-white text-[#042E4B] font-sans">
      {/* Background Container */}
      <div
        className="text-white h-screen"
        style={{
          backgroundImage: 'url("/landing-page-background.png")',
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* Header Section */}
        <header className="px-5 lg:px-20 pt-6 md:pt-8 pb-4 flex justify-between items-center bg-opacity-75">
          <div className="flex items-center gap-3">
            <img src="logo512teste.png" alt="Logo ThinkWay" className="h-8" />
            <p className="text-2xl font-semibold">ThinkWay</p>
          </div>

          <div className="flex items-center gap-5">
            <button className="text-white gap-1 hidden md:flex md:items-start" onClick={handleEntrar}>
              <LoginIcon />
              <p>Login</p>
            </button>

            {/* <Button
              variant="outlined"
              color="inherit"
              onClick={handleAssinaturaClick}
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              Assine Já
            </Button> */}

            {/* Mobile Menu Icon */}
            <button className="text-white flex gap-1 md:hidden" onClick={toggleModal}>
              <Menu />
            </button>
          </div>
        </header>

        {/* Modal for Mobile Menu */}
        <Modal open={isModalOpen} onClose={toggleModal}>
          <Box
            sx={{
              position: "absolute",
              top: "10px",
              right: "10px",
              width: 300,
              bgcolor: "#042E4B",
              boxShadow: 24,
              p: 4,
              color: "white",
              borderRadius: 2,
            }}
          >
            <div className="flex justify-between items-center mb-4">
              <Typography variant="h6" component="h2">
                Menu
              </Typography>
              <IconButton onClick={toggleModal}>
                <Close />
              </IconButton>
            </div>
            <ul className="space-y-4">
              <li>
                <Button
                  fullWidth
                  variant="contained"
                  sx={{ color: "white" }}
                  onClick={() => {
                    handleEntrar();
                    toggleModal();
                  }}
                  startIcon={<LoginIcon />}
                >
                  Login
                </Button>
              </li>
              {/* <li>
                <Button
                  fullWidth
                  variant="outlined"
                  sx={{ color: "white" }}
                  onClick={() => {
                    handleAssinaturaClick();
                    toggleModal();
                  }}
                >
                  Assine Já
                </Button>
              </li> */}
            </ul>
          </Box>
        </Modal>

        {/* Hero Section */}
        <section className="text-center lg:text-start lg:w-1/2 py-32 md:py-36 lg:py-44 xl:py-52 px-12 xs:px-20 md:px-36 lg:px-20 space-y-10">
          <div className="space-y-10">
            <h1 className="text-3xl md:text-4xl xl:text-5xl font-bold">
              Planeje o caminho até o sucesso com a <span className="text-[#ef613d]">ThinkWay</span> ao seu lado.
            </h1>
            <p className="text-xl font-semibold">
              Simplifique o desenvolvimento e a gestão do planejamento estratégico
              da sua empresa. Construa cenários, defina indicadores e alcance
              objetivos com uma plataforma intuitiva, acessível e com total autonomia.
            </p>
          </div>
        </section>
      </div>

      {/* Features Section */}
      <section className="py-24">
        <h2 className="text-4xl font-bold text-center mb-10 text-[#042E4B]">Principais Recursos</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 px-[14vw]">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 shadow-md rounded-lg border border-[#042E4B] text-center">
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-2xl font-semibold text-[#042E4B] mb-2">{feature.title}</h3>
              <p className="text-gray-700">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Video Section */}
      <section className="bg-white pb-24 text-center">
        <h2 className="text-4xl font-bold text-[#042E4B] mb-10 px-4">Como Podemos Ajudar</h2>
        <div className="flex flex-col lg:flex-row justify-center px-[14vw] gap-6 xl:gap-12 w-full">
          <iframe
            src="https://www.youtube.com/embed/1EwsC6QOWBE"
            title="Vídeo explicativo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="rounded-lg shadow-md w-full lg:w-1/2 max-w-[720px] h-[330px]"
          ></iframe>
          <div className="w-full lg:w-1/2">
            <p className="text-base xl:text-lg text-center lg:text-start text-[#042E4B]">
              Com a nossa plataforma, você terá acesso a ferramentas avançadas que facilitam a definição de metas claras e o monitoramento em tempo real do progresso da sua estratégia.
              O <strong>ThinkWay</strong> foi projetado de maneira intuitiva para simplificar processos complexos, permitindo que sua equipe se concentre no que realmente importa: impulsionar os resultados.
              Não importa o tamanho da sua empresa, nossa solução oferece a flexibilidade e o suporte necessários para crescer com confiança.
              Clique agora e transforme a maneira como sua empresa planeja o futuro!
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[#042E4B] text-white py-12">
        <div className="flex justify-between items-center px-5 lg:px-20">
          <div className="flex items-end">
            <img src="logo512teste.png" alt="Logo ThinkWay" className="h-24" />
          </div>
          <div className="hidden md:block">
            <h2 className="text-2xl font-bold">Lançamento Em Breve!</h2>
          </div>
          <div>
            <h2 className="text-white text-xl sm:text-2xl font-semibold mb-2 text-center">
              Entre em Contato
            </h2>
            <ul className="text-end">
              <li>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/company/think-way-planejamento-estrategico/posts/?feedView=all"
                  rel="noreferrer"
                  className="text-sm"
                >
                  Linkedin <LinkedIn fontSize="small" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.instagram.com/thinkway.app/"
                  rel="noreferrer"
                  className="text-sm"
                >
                  Instagram <Instagram fontSize="small" />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="mailto:thinkway.app@gmail.com"
                  rel="noreferrer"
                  className="text-sm"
                >
                  Email <Email fontSize="small" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;
